import { v4 as uuidv4 } from "uuid";
export class AssetControlTypeModel {
    constructor() {
        this.masterId = uuidv4();
    }
}
export default class AssetControlType extends AssetControlTypeModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
